import { createSelector } from '@reduxjs/toolkit';
import { selfClientSelector } from './self';

const selectedBlockSelector = createSelector(selfClientSelector, (clients) => clients.selectedBlock);

export default selectedBlockSelector;
